import './AgeWarningScreen.css'
import regImage from '../assets/images/reg.jpg'
import { Logo } from './Logo'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function AgeWarningScreen({ onAgree }: { onAgree: () => void }) {
  const handleDisagree = () => {
    window.Telegram?.WebApp?.close?.()
  }

  const [agreed, setAgreed] = useState(false)
  const { t } = useTranslation()

  return (
    <div className="age-warning-screen">
      <div className="overlay" />
      <img src={regImage} className="background" alt="background" />
      <div className="content">
       <Logo />
        <div className="terms">
        <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} />
        <label>
          {t('age_terms')}{' '}
          <a href="https://api.etojesim.com/user_terms.docx" target="_blank">
            {t('terms_of_use')}
          </a>
        </label>
        </div>
        <div className="buttons">
        <button
            className={`agree ${!agreed ? 'disabled' : ''}`}
            onClick={onAgree}
            disabled={!agreed}
            >
            {t('continue')}
            </button>
        <button className="disagree" onClick={handleDisagree}>{t('no_exit')}</button>
        </div>
      </div>
    </div>
  )
}
